__turbopack_context__.v({
  "header": "index-module__CYEKhG__header",
  "right": "index-module__CYEKhG__right",
  "rightWithHint": "index-module__CYEKhG__rightWithHint",
});
